
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Brain } from 'lucide-react';
import { TaxonomyLevel } from '@/types/supabase';
import { cn } from "@/lib/utils";

export interface TaxonomyBadgeProps {
  taxonomyLevel: TaxonomyLevel;
  className?: string;
}

const TaxonomyBadge: React.FC<TaxonomyBadgeProps> = ({ taxonomyLevel, className }) => {
  // Color mapping for each taxonomy level with improved contrast
  const taxonomyColors: Record<TaxonomyLevel, string> = {
    remember: 'bg-slate-300 text-slate-900 border-slate-400 shadow-sm',
    understand: 'bg-blue-300 text-blue-900 border-blue-400 shadow-sm',
    apply: 'bg-green-300 text-green-900 border-green-400 shadow-sm',
    analyze: 'bg-amber-300 text-amber-900 border-amber-400 shadow-sm',
    evaluate: 'bg-orange-300 text-orange-900 border-orange-400 shadow-sm',
    create: 'bg-red-300 text-red-900 border-red-400 shadow-sm'
  };

  return (
    <Badge 
      className={cn(
        taxonomyColors[taxonomyLevel],
        "font-medium border",
        className
      )}
    >
      <Brain className="mr-1 h-3 w-3" /> 
      {taxonomyLevel.charAt(0).toUpperCase() + taxonomyLevel.slice(1)}
    </Badge>
  );
};

export default TaxonomyBadge;
